export enum TestMethodGroupAddingOption {
  New = 'new',
  Existing = 'existing'
}
